import { Navigate, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { useHasTool } from "../access/AccessProvider";
import { getLazyToolComponent } from "../tools/registry";

function OkrsToolRoute() {
  const hasOkrs = useHasTool("okrs");
  if (!hasOkrs) {
    return <Navigate to="/settings" replace />;
  }

  const OkrsToolLayout = getLazyToolComponent("okrs");
  if (!OkrsToolLayout) {
    return <Navigate to="/settings" replace />;
  }

  return (
    <Suspense
      fallback={
        <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
          Loading OKRs…
        </div>
      }
    >
      <OkrsToolLayout />
    </Suspense>
  );
}

export const Route = createFileRoute("/_app/okrs")({
  component: OkrsToolRoute,
});
